import { EditorModals } from './EditorModals';
import { EditorPreview } from './EditorPreview';
import { EditorSidebar } from './EditorSidebar';

export const EditorMainContent = () => {
  return (
    <div className="relative flex h-full bg-white pt-12">
      {/* Sidebar */}
      <EditorSidebar />

      <div className="relative flex-1">
        {/* Preview Pane */}
        <EditorPreview />

        {/* All modals */}
        <EditorModals />
      </div>
    </div>
  );
};
